import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { isEmpty } from 'lodash';

import useGetMe from 'Domain/me/useGetMe';
import checkIsAccessGranted from 'Helper/checkIsAccessGranted';
import checkPublicRoute from 'Helper/checkPublicRoute';
import { useAppSystem } from 'Store/app';
import useIsMobile from 'Hook/useIsMobile';
import useLogout from 'Domain/logout/usePostLogout';

const AccessPermission = ({ children }) => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { onChangeAppSystem, onResetAppSystem } = useAppSystem();

  const { mutate: onLogout } = useLogout();

  const isPublic = checkPublicRoute(pathname);
  const { data, isLoading } = useGetMe({ isPublic });

  const { permissionList, userIdentity } = data ?? {};

  const cookies = new Cookies();
  const isLogin = cookies.get('token');

  useEffect(() => {
    onChangeAppSystem({ isLoadingPage: isLoading });

    return () => onResetAppSystem();
    /* eslint-disable-next-line */
  }, [isLoading]);

  useEffect(() => {
    const appVersion = process.env.REACT_APP_VERSION;
    const appVersionCookie = cookies.get('appVersion');

    const isGranted = checkIsAccessGranted({ pathname, permissionList });
    const isMainPage = pathname === '/';

    if (isLogin && !isPublic && String(appVersionCookie) !== String(appVersion)) onLogout({});

    //if not login and not public view
    if (!isLogin && !isPublic) navigate('/login');

    //if login and public view
    if (isLogin && isPublic && pathname !== '/forbidden') navigate(isMobile ? '/host' : '/');

    //if not public view and no access
    if (!isPublic && permissionList && !isGranted) navigate(isMobile ? '/host' : '/');

    //if operator but in mobile view
    if (isMobile && !isEmpty(userIdentity) && userIdentity?.isBackoffice) navigate('/forbidden');

    //if host but in desktop view
    if (!isMobile && !isEmpty(userIdentity) && !userIdentity?.isBackoffice) navigate('/forbidden');

    //if host redirect to /host
    if (isMobile && isMainPage) return navigate('/host');

    /* eslint-disable-next-line */
  }, [pathname, permissionList, isMobile, userIdentity]);

  return children;
};

export default AccessPermission;
